import { Query } from "../types";

export const prepareQuery = (params?: Query) => {
  if (!params || Object.keys(params).length === 0) return "";

  const queryList = Object.entries(params).flatMap(([key, value]) => {
    if (value === undefined || value === null) return [];

    if (Array.isArray(value)) {
      const filtered = (value as Array<string | number>).filter(
        (el) => el !== undefined && el !== null,
      );
      return filtered.length > 0
        ? filtered.map((el) => `${key}=${encodeURIComponent(el)}`)
        : [];
    }

    return [`${key}=${encodeURIComponent(value)}`];
  });

  return queryList.length ? `?${queryList.join("&")}` : "";
};
